import { useState, memo } from 'react'
import Skeleton from '../skeleton/Skeleton'
import CarInfoUserModal from '../modal/CarInfoUserModal'

function CarInfoUser({ car, customer_types, customer, setCar, isUser = false }) {
  const [showModal, setShowModal] = useState(false)
  const editUser = () => {
    setShowModal(true)
  }

  return (
    <>
      <div className="relative rounded-2xl border dark:border-gray-700 border-light-gray overflow-auto scroll-smooth">
        <table className="w-full text-sm text-right relative whitespace-nowrap">
          <thead className="text-md bg-light-blue dark:bg-slate-800 w-full">
            <tr className={'border-b border-b-light-gray dark:border-b-gray-700 text-center'}>
              {!isUser && (
                <th scope="col" className="px-6 py-4 dark:text-amber-100">
                  جنسیت
                </th>
              )}
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                نام و نام خانوادگی
              </th>
              {!isUser && (
                <th scope="col" className="px-6 py-4 dark:text-amber-100">
                  دسته بندی
                </th>
              )}
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                شماره همراه
              </th>
              {!isUser && (
                <th scope="col" className="px-6 py-4 dark:text-amber-100">
                  عملیات
                </th>
              )}
            </tr>
          </thead>

          <tbody className={'text-md bg-light-blue dark:bg-slate-800'}>
            {customer ? (
              <tr
                className={`border-b border-b-light-gray dark:border-b-gray-700 text-center border-r-4`}
                style={{ borderRightColor: `${customer?.customer_type?.color}` }}
              >
                {!isUser && <td className="px-6 py-4 dark:text-amber-50">{customer?.gender}</td>}
                <td className="px-6 py-4 dark:text-amber-50">{customer?.full_name}</td>
                {!isUser && (
                  <td className={`px-6 py-4`}>
                    <span style={{ color: `${customer?.customer_type?.color}` }}>
                      {customer?.customer_type?.value ? (
                        customer?.customer_type?.value
                      ) : (
                        <span className={'text-warning'}>تعریف نشده</span>
                      )}
                    </span>
                  </td>
                )}
                <td className="px-6 py-4 dark:text-amber-50">{customer?.mobile}</td>
                {!isUser && (
                  <td className="px-6 py-4">
                    <button
                      onClick={editUser}
                      className="font-medium text-link dark:text-link hover:underline"
                    >
                      ویرایش
                    </button>
                  </td>
                )}
              </tr>
            ) : (
              <tr className={`border-b border-b-light-gray text-center`}>
                <td className="px-6 py-4">
                  <Skeleton />
                </td>
                <td className="px-6 py-4">
                  <Skeleton />
                </td>
                <td className={`px-6 py-4`}>
                  <Skeleton />
                </td>
                <td className="px-6 py-4">
                  <Skeleton />
                </td>
                {!isUser && (
                  <td className="px-6 py-4">
                    <Skeleton />
                  </td>
                )}
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {showModal && (
        <CarInfoUserModal
          car={car}
          customer_types={customer_types}
          customer={customer}
          setCar={setCar}
          setShowModal={setShowModal}
        />
      )}
    </>
  )
}

export default memo(CarInfoUser)
